import { AssertionError } from './assertionError';
/**
 * The exception that is thrown when one an illegal state is identified.
 *
 * @param message The message that will be returned to the user
 */
export class IllegalStateException extends AssertionError {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : `Illegal State Exception`, 'IllegalStateException');
    }
}
//# sourceMappingURL=illegalStateException.js.map